import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { dict } from "./dict";
import { config } from "./config";
import { BettingHistory } from "./ui";
import { BettingHistoryState } from "./state";
import { Parser } from "../../parser";
import { Retriever } from "../../retriever";
import { BettingHistoryStorageInstance } from "../../storage";
import { requestOptions } from "../../constants";
import { DateRangePeriod } from "../../types";
import { getDictPhrase } from "../../helpers";
export class BettingHistoryRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        const mergedConfig = Object.assign(Object.assign({}, config), (options.cms || {}));
        this.dataProvider = new BettingHistoryState({
            dict: Object.assign(Object.assign({}, dict), (options.dict || {})),
            parser: new Parser({
                retriever: new Retriever({
                    request: Object.assign(Object.assign({}, requestOptions), (options.dataProvider.request || {})),
                    cache: BettingHistoryStorageInstance,
                    dateRange: options.dataProvider.dateRange || DateRangePeriod.Last24Hours,
                    betsReportingApiConnection: options.dataProvider.betsReportingApiConnection,
                    messageBus: options.messageBus,
                    config: mergedConfig,
                }),
                config: mergedConfig,
            }),
            numberOfRecordsToDisplay: options.dataProvider.numberOfRecordsToDisplay
        });
        this.props = { dataProvider: this.dataProvider };
    }
    getTabLabel() {
        return getDictPhrase(this.options.dict, "BettingHistoryTabLabel");
    }
    activate() {
        return super.activate(React.createElement(BettingHistory, Object.assign({}, this.props)));
    }
}
window["BettingHistory"] = BettingHistoryRoot;
window["BettingHistoryStorage"] = BettingHistoryStorageInstance;
broadcastBlockLoad("BettingHistory");
//# sourceMappingURL=index.js.map